import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01ae1e4a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=01ae1e4a&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=01ae1e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae1e4a",
  null
  
)

export default component.exports